import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "@/seo/pages.json";

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attr === "rel" ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(attr === "rel" ? "href" : "content", value);
};

// keeps title, description, canonical and robots in sync while navigating the app
export function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const route = pathname.replace(/(.)\/+$/, "$1");
    const page = seo.pages[route];
    const site = process.env.REACT_APP_SITE_URL;
    document.title = page?.title || "Pesky Pixel — vectorising made easy";
    setMeta('meta[name="description"]', "name", "description", page?.description || seo.pages["/"].description);
    setMeta('meta[name="robots"]', "name", "robots", page && !page.noindex ? "index, follow" : "noindex, follow");
    if (site) setMeta('link[rel="canonical"]', "rel", "canonical", `${site}${page ? route : "/"}`);
  }, [pathname]);
  return null;
}
